import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { FormattedMessage } from "react-intl";
import WarningImage from "../../assets/img/warning-icon.svg";
import DraggableModal from "./DraggableModal";
import DraggableModalHead from "./DraggableModal/DraggableModalHead";
import DraggableModalBody from "./DraggableModal/DraggableModalBody";

const useStyles = makeStyles(theme => ({
  modal: {
    width: "500px",
    [theme.breakpoints.down("md")]: {
      width: "90%",
    },
  },
  modalBody: {
    padding: "30px 20px 15px 20px",
    fontSize: 16,
    textAlign: "center",
  },
  modalFooter: {
    marginTop: 30,
    padding: "15px 0 0 0",
    borderTop: "1px solid #ddd",
  },
  btn: {
    padding: "5px 15px",
    fontSize: 12,
    fontWeight: 600,
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      opacity: 0.8,
    },
  },
  img: {
    marginRight: 20,
    width: 50,
  },
}));

const NoProductionSettingsModal = ({ open, setOpen }) => {
  const classes = useStyles();

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <DraggableModal
      open={open}
      handleClose={handleClose}
      customClass={classes.modal}
    >
      <DraggableModalHead
        handleClose={handleClose}
        title={<FormattedMessage id="product.edit" />}
      />
      <DraggableModalBody customClass={classes.modalBody}>
        <img src={WarningImage} alt="Warning" className={classes.img} />
        <FormattedMessage id="monitoring.folderCantBeSelected" />
        <Box className={classes.modalFooter} align="right">
          <Button className={classes.btn} onClick={handleClose}>
            <FormattedMessage id="btn.close" />
          </Button>
        </Box>
      </DraggableModalBody>
    </DraggableModal>
  );
};

NoProductionSettingsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
};

export default NoProductionSettingsModal;
